import { LoadingOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import React, { FC } from "react"
import { Route, Routes } from "react-router-dom"
import { publicRoutes } from "../../app/router"

const AppRouter: FC = () => {
  return (
    <React.Suspense fallback={<><div className="loading"><LoadingOutlined spin /></div></>}>
      <Routes>
        {publicRoutes.map(route => 
          <Route
            path={route.path}
            element={route.component}
            key={route.path}
            />
        )}
      </Routes>
    </React.Suspense>
  )
}

export default observer(AppRouter)